import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import BulletinSearchResults from './BulletinSearchResults';
import { getFullPermissions } from 'reducers/PermissionsReducer';
import { Redirect } from 'react-router-dom';

function AlertsSearch() {
  const permissions = getFullPermissions('cad', 'Alerts');
  if (!permissions.Read) return <Redirect to="/" />;
  return (
    <SearchMenu>
      <FilterConsumer>
        {(AgencyFilter) => <BulletinSearchResults filter={AgencyFilter} />}
      </FilterConsumer>
    </SearchMenu>
  );
}

export default AlertsSearch;
